<script>
	import { getSupportedLanguagesAry } from "$lib/utilities/translate";
	import { store } from "$lib/utilities/store";

	import FileInput from "./FileInput.svelte";
	import Textarea from "./Textarea.svelte";
	import TextInput from "./TextInput.svelte";
	import UpdateTranslation from "$lib/sections/Admin/UpdateTranslation.svelte";

	export let image;
	export let path;
	export let handleChange = async () => {};
	export let key = "";
	export let lang;
	export let col;
	export let settingId;
	export let itemId;

	let supportedLanguagesAry = [];
	$: (() => {
		const { supportedLanguagesAry: ary } = getSupportedLanguagesAry(
			$store?.settings?.docs?.languages,
		);
		supportedLanguagesAry = ary;
	})();
</script>

<div class="m-auto">
	<div class="lg:flex lg:gap-2 text-nowrap">
		<div>
			<div class="flex gap-2">
				<div>
					{#if image?.blob || image?.downloadUrl}
						{#if image?.type === "video/mp4"}
							<video
								autoplay
								muted
								loop
								playsinline
								preload="auto"
								class="h-16 border border-current rounded"
							>
								<source
									src={image?.blob || image?.downloadUrl}
									type="video/mp4"
								/>
							</video>
						{:else}
							<img
								src={image?.blob || image?.downloadUrl}
								alt={"input"}
								class="h-16 border border-current rounded"
							/>
						{/if}
					{/if}
				</div>
				<div>
					<div>{image?.type}</div>
					<div>{image?.formattedSize}</div>
					<div>
						{image?.width} x {image?.height}
					</div>
				</div>
			</div>
			<div>
				{image?.name}
			</div>
		</div>

		<div>
			<div class="grid grid-cols-3 gap-2 lg:block">
				<FileInput
					bind:docData={image}
					{path}
					{handleChange}
					{key}
					{itemId}
				/>
			</div>
		</div>

		<div>
			<div class="m-1">import query:</div>
			{#if typeof image === "object"}
				<TextInput
					label={`${image?.name || "new"} query`}
					{key}
					bind:value={image.query}
					handleInputChange={handleChange}
					{itemId}
				/>
			{/if}
		</div>

		<div class="flex">
			<div>
				<div class="m-1">image description:</div>
				<UpdateTranslation {key} {col} {settingId} {lang} />
				<div class="flex w-full justify-between">
					<div>translations</div>
					<div
						class={Object.keys(
							image?.description?.translations || {},
						).length === supportedLanguagesAry.length
							? "text-green-400"
							: "text-red-400"}
					>
						{Object.keys(image?.description?.translations || {})
							.length}
					</div>
				</div>
			</div>

			<div class="ml-1">
				{#if typeof image === "object" && typeof image.description === "object"}
					{#if lang}
						lang:{lang}
						{#if image.description?.translations?.[lang]}
							<Textarea
								label={`${image?.name || "new"} image description`}
								{key}
								bind:value={
									image.description.translations[lang]
								}
								handleInputChange={handleChange}
								{itemId}
							/>
						{:else}
							<div>translation not available</div>
						{/if}
					{:else}
						<Textarea
							label={`${image?.name || "new"} image description`}
							{key}
							bind:value={image.description.value}
							handleInputChange={handleChange}
							{itemId}
						/>
					{/if}
				{/if}
			</div>
		</div>
	</div>
</div>
